var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
// styles
import "./toggle.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-toggle",
    value: false,
    color: "primary",
    disabled: false,
    size: "medium",
};
const Toggle = (_a) => {
    var { value, onChange, color, disabled, size, className, label, helpText, error } = _a, rest = __rest(_a, ["value", "onChange", "color", "disabled", "size", "className", "label", "helpText", "error"]);
    const classList = classNames("tecma-toggle", { [`${color}`]: color }, { active: value }, { disabled }, { size }, { [`${size}`]: size }, className);
    return (_jsxs("div", { className: "tecma-toggle-container", children: [label && _jsx("span", { className: "toggle-label", children: label }), _jsx("div", Object.assign({ className: classList }, rest, { children: _jsx("div", { className: "toggle-element", onClick: onChange, role: "button", "aria-label": "toggle-button", onKeyDown: onChange, tabIndex: 0 }) })), helpText && (_jsx("span", { className: error ? "toggle-helpText toggle-helpText-errored" : "toggle-helpText", children: helpText }))] }));
};
Toggle.defaultProps = defaultProps;
/**
 * The Toggle is a boolean input field mostly used to get a boolean-like response from the user:
 * *yes/no*, *true/false*, etc...
 */
export default React.memo(Toggle);
